<template>
	<v-dialog :model-value="isActive" width="1000" persistent>
		<v-card>
			<v-card-title class="text-h1 font-weight-bold pt-4 px-6">
				Insert Playlist Event
				<v-spacer></v-spacer>
				<v-btn icon="mdi-close" variant="flat" density="compact" @click="$emit('close')">
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-0">
				<v-row align="center">
					<v-col class="text-caption" cols="3">
						Spot Block
					</v-col>
					<v-col class="text-caption d-flex flex-nowrap align-center" cols="5">
						Length (minutes:seconds):
						<v-text-field v-model="spotBlockData.minutes" type="number" label="mm" variant="outlined"
							density="compact"
							hide-details/>
						:
						<v-text-field v-model="spotBlockData.seconds" type="number" label="ss" variant="outlined"
							density="compact"
							hide-details/>
					</v-col>
					<v-col cols="2">
						<v-checkbox v-model="spotBlockData.network" label="Network" hide-details/>
					</v-col>
					<v-col class="d-flex justify-end" cols="2">
						<v-btn icon="mdi-plus-box" density="compact" variant="plain" color="green" size="x-large"
							@click="createSpotBlock"/>
					</v-col>
				</v-row>
				<v-divider/>
				<v-row align="center">
					<v-col class="text-caption" cols="3">
						Exact Time Marker
					</v-col>
					<v-col class="text-caption d-flex flex-nowrap align-center" cols="5">
						Time (minutes:seconds):
						<v-text-field v-model="etmData.minutes" type="number" label="mm" variant="outlined"
							density="compact"
							hide-details/>
						:
						<v-text-field v-model="etmData.seconds" type="number" label="ss" variant="outlined"
							density="compact"
							hide-details/>
					</v-col>
					<v-col cols="2">
						<v-select v-model="etmData.item" :items="etmItems" item-value="value" item-title="title"
							variant="outlined" density="compact"
							hide-details/>
					</v-col>
					<v-col class="d-flex justify-end" cols="2">
						<v-btn icon="mdi-plus-box" density="compact" variant="plain" color="green" size="x-large"
							@click="createETM"/>
					</v-col>
				</v-row>
				<v-divider/>
				<v-row align="center">
					<v-col class="text-caption" cols="3">
						Comment
					</v-col>
					<v-col>
						<v-text-field v-model="comment" variant="outlined" density="compact" hide-details/>
					</v-col>
					<v-col class="d-flex justify-end" cols="2">
						<v-btn icon="mdi-plus-box" density="compact" variant="plain" color="green" size="x-large"
							@click="createComment"/>
					</v-col>
				</v-row>
				<v-divider/>
				<v-row align="center">
					<v-col class="text-caption" cols="3">
						Resolve Tag Event
					</v-col>
					<v-col>
						<v-text-field v-model="resolveTag" label="Resolve Tag" variant="outlined" density="compact"
							hide-details/>
					</v-col>
					<v-col class="d-flex justify-end" cols="2">
						<v-btn icon="mdi-plus-box" density="compact" variant="plain" color="green" size="x-large"
							@click="createResolveTag"/>
					</v-col>
				</v-row>
				<v-divider/>
				<v-row align="center">
					<v-col class="text-caption" cols="3">
						Mode Selection
					</v-col>
					<v-col>
						<v-select label="Select mode" v-model="selectedMode" :items="availableModes" item-value="value"
							item-title="title" variant="outlined" density="compact" hide-details/>
					</v-col>
					<v-col class="d-flex justify-end" cols="2">
						<v-btn icon="mdi-plus-box" density="compact" variant="plain" color="green" size="x-large"
							@click="createModeSelectionEvent" :disabled="!this.selectedMode"/>
					</v-col>
				</v-row>
				<v-row v-if="isLiveShowPlaylist" align="center">
					<v-col class="text-caption" cols="3">
						Live Show event
					</v-col>
					<v-col>
						<v-select label="Select Live Show event"
							v-model="selectedLiveShowEvent" :items="liveShowEventItems"
							item-value="value" item-title="title"
							variant="outlined" density="compact" hide-details/>
					</v-col>
					<v-col class="d-flex justify-end" cols="2">
						<v-btn icon="mdi-plus-box" density="compact" variant="plain" color="green" size="x-large"
							@click="createLiveShowEvent" :disabled="!this.selectedLiveShowEvent"/>
					</v-col>
				</v-row>
				<v-divider/>
				<v-row align="center">
					<v-col class="text-caption" cols="3">
						Rejoin
					</v-col>
					<v-col class="d-flex justify-end">
						<v-btn icon="mdi-plus-box" density="compact" variant="plain" color="green" size="x-large"
							@click="createRejoinEvent"/>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
/* Libraries */
import * as _ from "lodash";
import moment from "moment";

/* Enums */
import ChainTypes from "@/enums/ChainTypes";
import EventStatus from "@/enums/EventStatus";
import EventTypes from "@/enums/EventTypes";
import ExecuteCommandTypes from "@/enums/ExecuteCommandTypes";
import PlaylistTypes from "@/enums/PlaylistTypes";
import SequencerModes from "@/enums/SequencerModes";
import ShowIntegrationType from "@/enums/ShowIntegrationType";
import SyndicationTypes from "@/enums/SyndicationTypes";

export default {
	name: "InsertEventDialog",

	props: ["isActive", "selectedStation", "event", "playlistID", "insideSpotBlock", "show"],

	emits: ["close"],

	data() {
		return {
			spotBlockData: {
				minutes: null,
				seconds: null,
				network: false
			},
			etmData: {
				minutes: null,
				seconds: null,
				item: 4
			},
			etmItems: [
				{
					value: 1,
					title: 'Hard'
				},
				{
					value: 2,
					title: 'Soft'
				},
				{
					value: 3,
					title: 'Reset'
				},
				{
					value: 4,
					title: 'Hit'
				}
			],
			comment: null,
			resolveTag: this.$store.getters.getResolveTagText(),
			selectedMode: null,
			availableModes: this.selectedStation?.AvailableModes?.reduce((array, mode) => {
				// for the Split mode, ensure if the station's syndication type is not Split master
				if (mode !== SequencerModes.Split ||
					this.selectedStation?.SyndicationType !== SyndicationTypes.SplitMaster) {
					array.push({
						value: mode,
						title: SequencerModes.getName(mode)
					});
				}

				return array;
			}, []) ?? [],
			liveShowEventItems: [
				{value: ExecuteCommandTypes.SyndicationOriginationStart, title: "Start Live Show"},
				{value: ExecuteCommandTypes.SyndicationOriginationEnd, title: "End Live Show"}
			],
			selectedLiveShowEvent: null
		};
	},

	computed: {
		isLiveShowPlaylist() {
			return this.selectedStation?.SyndicationType === SyndicationTypes.SyndicationOrigination &&
				   this.show?.integration_type === ShowIntegrationType.Originated;
		},

		spotBlockLength() {
			return this.spotBlockData.minutes * 60 + parseInt(this.spotBlockData.seconds);
		},

		etmTime() {
			if (_.isNil(this.etmData.minutes) && _.isNil(this.etmData.seconds)) {
				return null;
			}
			return (this.etmData.minutes ?? 0) * 60 + parseInt(this.etmData.seconds ?? 0);
		}
	},

	methods: {
		createSpotBlock() {
			this.$store.dispatch("createPlaylist", {
				StationID: this.selectedStation.StationID,
				OrganizationID: this.$store.getters.getOrgID(),
				Title: `Manually Inserted Spot Block - ${this.$store.getters.getUserFullName()}`,
				PlaylistType: this.spotBlockData.network ? PlaylistTypes.NetworkSpotBlock : PlaylistTypes.SpotBlock,
				Priority: 99,
				TargetLength: this.spotBlockLength,
				CreatedDateTime: moment.tz(
					moment().format("YYYY-MM-DD HH:mm:ss"),
					this.selectedStation.StationTimeZone
				),
				Events: []
			}).then(newSpotBlockPlaylist => {
				const newSpotBlockEvent = this.generatePlaylistEvent({
					EventType: EventTypes.SpotBlock,
					PlaylistID: this.playlistID,
					ChildPlaylistID: newSpotBlockPlaylist.PlaylistID,
					Chain: ChainTypes.Segue,
					BlockType: this.spotBlockData.network ? 2 : 1
				});

				this.createPlaylistEvent(newSpotBlockEvent, this.event);
			})
		},

		createETM() {
			const newEvent = this.generatePlaylistEvent({
				EventType: EventTypes.ETM,
				PlaylistID: this.playlistID,
				EtmType: this.etmData.item,
				HardTime: this.etmTime
			});
			this.createPlaylistEvent(newEvent, this.event);
		},

		createComment() {
			const newEvent = this.generatePlaylistEvent({
				EventType: EventTypes.Comment,
				PlaylistID: this.playlistID,
				Description: this.comment
			});
			this.createPlaylistEvent(newEvent, this.event);
		},

		createResolveTag() {
			this.$store.commit("setResolveTagText", this.resolveTag);
			const newEvent = this.generatePlaylistEvent({
				EventType: EventTypes.PlayAsset,
				PlaylistID: this.playlistID,
				Chain: ChainTypes.LinkSong,
				ResolveTags: [this.resolveTag]
			});
			this.createPlaylistEvent(newEvent, this.event);
		},

		createModeSelectionEvent() {
			const newEvent = this.generatePlaylistEvent({
				EventType: EventTypes.ExecuteCommand,
				PlaylistID: this.playlistID,
				ExecuteCommand: {
					ExecuteCommandType: 4, // Mode Change
					ModeChange: {
						NewMode: this.selectedMode
					}
				}
			});
			this.createPlaylistEvent(newEvent, this.event);
		},

		createLiveShowEvent() {
			const newEvent = this.generatePlaylistEvent({
				EventType: EventTypes.ExecuteCommand,
				PlaylistID: this.playlistID,
				ExecuteCommand: {
					ExecuteCommandType: this.selectedLiveShowEvent
				}
			});
			this.createPlaylistEvent(newEvent, this.event);
		},

		createRejoinEvent() {
			const newEvent = this.generatePlaylistEvent({
				EventType: EventTypes.Rejoin,
				PlaylistID: this.playlistID
			});
			this.createPlaylistEvent(newEvent, this.event);
		},

		generatePlaylistEvent(data) {
			const newEventAttributes = [
				"PlaylistID", "SequenceNumber", "EventType", "Chain", "AssetID", "AssetTypeID", "HardTime", "EtmType",
				"Description", "ChildPlaylistID", "BlockType", "ResolveTags", "ExecuteCommand"
			];

			let playlistEvent = _.omitBy(_.pick(data, newEventAttributes), attr => _.isUndefined(attr));    // keep only the values from the newEventAttributes array, omitting the undefined ones
			playlistEvent.StatusCode = EventStatus.Ready;
			playlistEvent.Skipped = false;

			return playlistEvent;
		},

		async createPlaylistEvent(newEvent, targetEvent, afterEvent = true) {
			this.$store.commit("setBlinkingEvent", {
				eventID: targetEvent.EventID,
				status: true
			});
			this.$emit("close");
			if (this.insideSpotBlock) {
				if (_.isEmpty(targetEvent?.ChildPlaylist?.Events)) {
					newEvent.SequenceNumber = 1;
				}
				else {
					newEvent.SequenceNumber = (await this.$store.dispatch("generateSequenceNumber", {
						eventID: targetEvent?.ChildPlaylist?.Events[0].EventID,
						afterEvent: false
					})).data[0];
				}
			}
			else {
				newEvent.SequenceNumber = (await this.$store.dispatch("generateSequenceNumber", {
					eventID: targetEvent.EventID,
					afterEvent: afterEvent
				})).data[0];
			}

			const parentPlaylist = this.$store.getters.getPlaylistById(
				{stationID: this.selectedStation.StationID, playlistID: this.playlistID}
			);
			newEvent = {
				...newEvent,
				ParentScheduledStartDateTime: parentPlaylist?.ScheduledStartDateTime,
				StationID: this.selectedStation.StationID
			}

			this.$store.dispatch("createPlaylistEvent", newEvent).then(() => {
				this.$store.commit(
					"SHOW_SUCCESS_NOTIFICATION",
					{message: "Event successfully created!"}
				);
			}).catch(() => {
				this.$store.commit(
					"SHOW_NOTIFICATION_WITH_TYPE",
					{message: "An error occurred when trying to create the event."}
				);
			}).finally(() => {
				this.$store.commit("setBlinkingEvent", {
					eventID: targetEvent.EventID,
					status: false
				});

			});
		}
	},

	mounted() {
		if (this.event) {
			const eventAirtime = moment.tz(this.event.AirStartDateTime, this.$store.getters.stationTimezone());
			this.etmData.minutes = eventAirtime.minutes();
			this.etmData.seconds = eventAirtime.seconds();
		}
	}
}
</script>

<style scoped lang="scss">

.v-row {
	margin: 0;
}

</style>